import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { GoogleButton, OrDivider } from "@/components/GoogleButton";

export default function Register() {
  const { applyAuth } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      applyAuth(data);
      if (data.dev_verification_link) sessionStorage.setItem("cgland_dev_verify_link", data.dev_verification_link);
      toast.success("Account created. Please verify your email.");
      navigate("/dashboard");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <AuthLayout testId="register-page" title="Create your account" subtitle="Start free. Upgrade to premium whenever you need maps."
      footer={<span>Already registered? <Link to="/login" data-testid="register-login-link" className="text-emerald-800 dark:text-emerald-400 font-semibold">Log in</Link></span>}>
      <GoogleButton testId="register-google-button" label="Sign up with Google" />
      <div className="my-5"><OrDivider /></div>
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2"><Label htmlFor="name">Full name</Label><Input id="name" data-testid="register-name-input" value={form.name} onChange={set("name")} required minLength={2} placeholder="Ramesh Sahu" className="h-11 rounded-xl" /></div>
        <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" data-testid="register-email-input" value={form.email} onChange={set("email")} required placeholder="you@example.com" className="h-11 rounded-xl" /></div>
        <div className="space-y-2"><Label htmlFor="password">Password</Label><Input id="password" type="password" data-testid="register-password-input" value={form.password} onChange={set("password")} required minLength={8} placeholder="At least 8 characters" className="h-11 rounded-xl" /></div>
        {error && <p data-testid="register-error" className="text-sm text-red-600 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900 rounded-lg px-3 py-2">{error}</p>}
        <Button data-testid="register-submit-button" type="submit" disabled={loading} className="w-full h-11 rounded-full bg-emerald-900 hover:bg-emerald-800 dark:bg-emerald-500 dark:text-slate-950 font-semibold">
          {loading ? "Creating account…" : "Create account"}
        </Button>
      </form>
    </AuthLayout>
  );
}
